export const BRAND = {
  name: "GigDrive Rentals",
  short: "GigDrive",
  tagline: "Rideshare-ready cars built for hustlers.",
  logo: "https://customer-assets.emergentagent.com/job_flex-drive-1/artifacts/fb2eanmp_6458A73C-1705-4FF4-A3BF-B072DBF35C22.png",
  heroBg: "https://static.prod-images.emergentagent.com/jobs/7f81a22a-f95d-491d-8e23-9630a1e92a84/images/d05f09222654007d90fbbc1277e1a0a2393962d2f0b091e31f7c4113c4a0c86c.png",
  textureBg: "https://static.prod-images.emergentagent.com/jobs/7f81a22a-f95d-491d-8e23-9630a1e92a84/images/bd91e8ef6ea76742ad7bf135c4fc0a33aa4926c6b36cfabf46240bda90945660.png",
  phone: "(202) 768-8713",
  phoneRaw: "2027688713",
  email: "gigdriverentals@yahoo.com",
};

export const GIG_PLATFORMS = [
  "Uber",
  "Lyft",
  "DoorDash",
  "Uber Eats",
  "Instacart",
  "Grubhub",
  "Amazon Flex",
  "Shipt",
  "Spark",
  "Other",
];

export const VEHICLE_PREFS = [
  { value: "economy", label: "Economy (best for delivery)" },
  { value: "midsize", label: "Midsize Sedan (UberX / Comfort)" },
  { value: "suv", label: "SUV (XL / Cargo)" },
  { value: "any", label: "Any car — best price wins" },
];

export const DURATIONS = [
  { value: "weekly", label: "Weekly (flexible)" },
  { value: "monthly", label: "Monthly (best rate)" },
  { value: "long-term", label: "Long-term (3+ months)" },
];

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"
];
